var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53516 6.98242V3.53906H6.98047C7.25977 3.53906 7.48633 3.3125 7.48633 3.0332V2.42578C7.48633 2.14648 7.25977 1.91992 6.98047 1.91992H2.30469C2.08984 1.91992 1.91406 2.0957 1.91406 2.31055V6.98633C1.91406 7.26562 2.14063 7.49219 2.41992 7.49219H3.02734C3.30859 7.49023 3.53516 7.26367 3.53516 6.98242ZM13.0586 3.53906H16.5039V6.98438C16.5039 7.26367 16.7305 7.49023 17.0098 7.49023H17.6172C17.8965 7.49023 18.123 7.26367 18.123 6.98438V2.30859C18.123 2.09375 17.9473 1.91797 17.7324 1.91797H13.0586C12.7793 1.91797 12.5527 2.14453 12.5527 2.42383V3.03125C12.5527 3.31055 12.7793 3.53906 13.0586 3.53906ZM6.98047 16.5078H3.53516V13.0625C3.53516 12.7832 3.30859 12.5566 3.0293 12.5566H2.42188C2.14258 12.5566 1.91602 12.7832 1.91602 13.0625V17.7383C1.91602 17.9531 2.0918 18.1289 2.30664 18.1289H6.98242C7.26172 18.1289 7.48828 17.9023 7.48828 17.623V17.0156C7.48633 16.7344 7.25977 16.5078 6.98047 16.5078ZM16.5039 13.0625V16.5078H13.0586C12.7793 16.5078 12.5527 16.7344 12.5527 17.0137V17.6211C12.5527 17.9004 12.7793 18.127 13.0586 18.127H17.7344C17.9492 18.127 18.125 17.9512 18.125 17.7363V13.0625C18.125 12.7832 17.8984 12.5566 17.6191 12.5566H17.0117C16.7305 12.5566 16.5039 12.7832 16.5039 13.0625Z",
    fill: "#2469EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBig);
export default __webpack_public_path__ + "static/media/big.d6b42603fcc68a599b00b6015e3136dc.svg";
export { ForwardRef as ReactComponent };